import React, { useState, useEffect } from 'react';
import { FECHA_NAC_MIN, FECHA_NAC_MAX } from '../../../components/fechaNacimiento';
import axios from '../../../axiosConfig';

import { Form, Button, Modal, Table,Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import SelectComponent from '../../../components/SelectComponent';
import './CreateVoluntariados.css';
import { toast } from 'react-toastify';
import { Card, Row, Col } from 'react-bootstrap';
import { useLoading } from '../../../components/LoadingContext';
import { FaSearch } from 'react-icons/fa';  // Importamos íconos de react-icons







const CreateVoluntariados = () => {
  const { setLoading } = useLoading();

  const [cedulaError, setCedulaError] = useState(''); // Estado para almacenar el mensaje de validación
  const [isCedulaValid, setIsCedulaValid] = useState(false);

  const [cedulaLengthError, setCedulaLengthError] = useState('');

  const [selectedUserName, setSelectedUserName] = useState(''); // Nombre del usuario seleccionado
  const [showRoleSearchModal, setShowRoleSearchModal] = useState(false);  // Modal de búsqueda de roles
  const [roles, setRoles] = useState([]);  // Lista de roles
  const [selectedRoleId, setSelectedRoleId] = useState(null);  // ID del rol seleccionado
  const [selectedRoleName, setSelectedRoleName] = useState('');  // Nombre del rol seleccionado
  const [filteredRoles, setFilteredRoles] = useState([]);
  const [searchRoleName, setSearchRoleName] = useState(''); // Estado específico para la búsqueda de roles
  const [showUserRoleModal, setShowUserRoleModal] = useState(false); 
  const [showUserSearchModal, setShowUserSearchModal] = useState(false);  // Modal de búsqueda de usuarios
  const [users, setUsers] = useState([]);  // Lista de usuarios
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchName, setSearchName] = useState('');
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [comentario, setComentario] = useState('');  // Nuevo estado para el comentario
  const [allUsers, setAllUsers] = useState([]); // Todos los usuarios cargados
  const [paginatedUsers, setPaginatedUsers] = useState([]); // Usuarios en la página actual
  const [currentPageUsers, setCurrentPageUsers] = useState(1);
  const [allRoles, setAllRoles] = useState([]); // Todos los roles cargados
  const [paginatedRoles, setPaginatedRoles] = useState([]); // Roles en la página actual
  const [currentPageRoles, setCurrentPageRoles] = useState(1);
  const navigate = useNavigate();
  const [totalPages, setTotalPages] = useState(1); // Default to 1 page initially
  const [showConfirmModal, setShowConfirmModal] = useState(false);  
  const userRole = localStorage.getItem('role');
  const userId = parseInt(localStorage.getItem('user'));  // ID del usuario logueado

  const itemsPerPage = 8; // Elementos por página
 
  const [formData, setFormData] = useState({
    cedula_identidad: '',
    nombres: '',
    apellidos: '',
    fecha_nacimiento: '',
    direccion: '',
    email: '',
    telefono_casa: '',
    telefono_celular: '',
    genero_id: '',
    nivel_instruccion_id: '',
    procedencia_id: '',
    como_entero_superatec_id: '',
    tipo_voluntariado_id: '',
    area_voluntariado_id: '',
    centro_id: '',
    actividades_realizar: '',
    fecha_inicio: '',
    fecha_fin:'',
    horas_totales: '',
    horario:'',
    eval_voluntariado_id:'',
    comentarios:'',
  });
  const [filterOptions, setFilterOptions] = useState({
    generoOptions: [],
    nivelOptions: [],
    procedenciaOptions: [],
    superatecOptions: [],
    tipoOptions: [],
    areaOptions: [],
    centroOptions: [],
    EvalOptions:[],
  });

  useEffect(() => {
    HandleSelected();
    if (showUserSearchModal) {
      getAllUsers();
    } else if (showRoleSearchModal) {
      getAllRoles();
    }
  }, [showUserSearchModal, showRoleSearchModal]);


  const [filters, setFilters] = useState({
    username:'',
    name:''
  });
   console.log("mi puto rol es ", userRole);

  const getAllUsers = async (page = 1) => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`/users-paginate`, {
            headers: { Authorization: `Bearer ${token}` },
            params: { ...filters, page }, // Incluye `page` en los parámetros
        });

        const { data, last_page, current_page } = response.data.users;

        // Actualizar el estado
        setPaginatedUsers(data); // Datos de la página actual
        setCurrentPageUsers(current_page); // Página actual
        setTotalPages(last_page); // Total de páginas
    } catch (error) {
        console.error('Error fetching users:', error);
        toast.error('Error fetching data');
        setPaginatedUsers([]); // Limpia los datos en caso de error
    }
};


const getAllRoles = async (page = 1) => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`/role-paginate`, {
            headers: { Authorization: `Bearer ${token}` },
            params: { ...filters, page }, // Incluye `page` en los parámetros
        });

        const { data, last_page, current_page } = response.data.roles;

        setPaginatedRoles(data); // Datos de la página actual
        setCurrentPageRoles(current_page); // Página actual
        setTotalPages(last_page); // Total de páginas
    } catch (error) {
        console.error('Error fetching roles:', error);
        toast.error('Error fetching data');
        setPaginatedRoles([]); // Limpia los datos en caso de error
    }
};




const handleFilterChange = (e) => {
  const { name, value } = e.target;
  setFilters(prev => ({ ...prev, [name]: value }));
};


const handleUserPageChange = async (newPage) => {
  if (newPage >= 1 && newPage <= totalPages) {
      await getAllUsers(newPage);
  }
};

const handleRolePageChange = async (newPage) => {
  if (newPage >= 1 && newPage <= totalPages) {
      await getAllRoles(newPage);
  }
};

const handleSelectUser = (user) => {
    setSelectedUserId(user.id);
    setSelectedUserName(user.username);
    setSelectedRoleId(null); // Limpiar selección de rol al seleccionar usuario
    setSelectedRoleName('');
    setShowUserSearchModal(false);
    setShowConfirmModal(true);
  };

  const handleSelectRole = (role) => {
    setSelectedRoleId(role.id);
    setSelectedRoleName(role.name);
    setSelectedUserId(null); // Limpiar selección de usuario al seleccionar rol
    setSelectedUserName('');
    setShowRoleSearchModal(false);
    setShowConfirmModal(true);
  };

const handleChangeNumber = (e) => {
  const { name, value } = e.target;

  // Permitir solo dígitos
  let newValue = value.replace(/\D/g, "");

  // Evitar que el primer dígito sea 0
  if (newValue.startsWith("0")) {
    newValue = newValue.slice(1);
  }

  // Limitar longitud a 10 caracteres
  if (newValue.length > 10) {
    newValue = newValue.slice(0, 10);
  }

  setFormData((prev) => ({
    ...prev,
    [name]: newValue,
  }));
};



  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;

    let updatedValue = value;

    if (name === 'cedula_identidad') {
      updatedValue = value.replace(/^V-/, '');  
      updatedValue = updatedValue.replace(/\D/g, ''); 
      if (updatedValue.length < 7) {
        setCedulaLengthError('La cédula debe tener al menos 7 caracteres.');
        setIsCedulaValid(false);
      } else {
        setCedulaLengthError('');
        setIsCedulaValid(true);
      }
    }

    setFormData(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : updatedValue,
    }));
  };

  const HandleSelected = async () => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`/filter-voluntariados`, { headers: { Authorization: `Bearer ${token}` } });

        const {centro,area_voluntariado,nivel,genero,procedencia,superatec,tipo_voluntariado,eval_voluntariado}=response.data;
        setFilterOptions({
        centroOptions:centro,
        areaOptions: area_voluntariado,
        nivelOptions: nivel,
        generoOptions:genero,
        procedenciaOptions:procedencia,
        superatecOptions:superatec,
        tipoOptions:tipo_voluntariado,
        EvalOptions:eval_voluntariado,

        

        });
 
    } catch (error) {
        console.error('Error fetching filter options:', error);
    }
};


// const handleSubmit = async (e) => {
//   e.preventDefault();
//   setLoading(true);


//   try {
//       const token = localStorage.getItem('token');
//       if (!token) {
//           toast.error('Error: Token no encontrado');
//           setLoading(false);
//           return;
//       }

//       const formDataWithStatus = {
//           ...formData,
//       };

//       // 1. Crear el curso primero
//       const cursoResponse = await axios.post(`/voluntariados`, formDataWithStatus, {
//           headers: { Authorization: `Bearer ${token}` },
//       });

//       toast.success('Nuevo Voluntariado agregado con Éxito');

//           navigate('/voluntariados');
      
//   } catch (error) {
//       toast.error('Error al crear Voluntariado ');
//       console.error('Error creando Voluntariado ', error);
//   } finally {
//       setLoading(false);
//   }
// };

 const handleConfirmSendRequest = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        toast.error('Error: Token no encontrado');
        return;
      }

      const formDataWithStatus = { ...formData, confirmar:false };
      const cursoResponse = await axios.post(`/voluntariados`, formDataWithStatus, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const id = cursoResponse.data.personales_voluntariados.id;
      const requestData = {
        user_id: userId,
        destinatario_id: selectedUserId || null,
        role_id: selectedRoleId || null,
        zona_id: 19,
        status: false,
        finish_time: null,
        key: id,
        comentario: comentario
      };

      await axios.post(`/peticiones`, requestData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success('Solicitud y voluntariado  enviados exitosamente');
      navigate('/voluntariados');
    } catch (error) {
      toast.error('Error al enviar la solicitud o voluntariados');
      console.error('Error al enviar la solicitud o voluntariados :', error);
    }
  };

const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    console.log("mi fack rol es ", userRole);


      if (userRole!=='admin') {

      setShowConfirmModal(true);
      setLoading(false);
      return;
    }

    try {
        const token = localStorage.getItem('token');
        if (!token) {
            toast.error('Error: Token no encontrado');
            setLoading(false);
            return;
        }

        const formDataWithStatus = {
            ...formData,
            confirmar:true,
        };

        // 1. Crear el curso primero
        const cursoResponse = await axios.post(`/voluntariados`, formDataWithStatus, {
            headers: { Authorization: `Bearer ${token}` },
        });

        toast.success('Nueva voluntariados agregada con Éxito');

            navigate('/voluntariados');
        
    } catch (error) {
        toast.error('Error al crear Voluntariado ');
        console.error('Error creando Voluntariado ', error);
    } finally {
        setLoading(false);
    }
};

  const handleBlur = async () => {
    if (formData.cedula_identidad) {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`/voluntariados/cedula/${formData.cedula_identidad}`,{headers: {
          Authorization: `Bearer ${token}`,
      }});
        // Si la cédula está registrada, mostramos el error y no es válida
        setCedulaError('La cédula ya está registrada.');
        setIsCedulaValid(false);
      } catch (error) {
        if (error.response && error.response.status === 404) {
          // La cédula no está registrada, por lo que es válida
          setCedulaError('');
          setIsCedulaValid(true);
        } else {
          console.error('Error checking cedula:', error);
          setCedulaError('Error verificando la cédula.');
          setIsCedulaValid(false);
        }
      }
    }
  };

  return (


    <div className="container-fluid" style={{ marginTop: '50px'}}>
    <Form onSubmit={(e) => handleSubmit(e, false)} className="custom-gutter">
  <div className="row justify-content-center" >
  <div className="col-lg-6 " > {/* Centrado del contenido */}
  <h2 className="mb-2">Agregar Nuevo voluntariado</h2>
  <div className="card-box" style={{ padding: '20px',  }}>
  <h4 className="mb-4">Datos del Voluntariado</h4>
        <script src="{{ mix('js/app.js') }}"></script>
        <div className="row">
          <div className="col-md-6">
          <Form.Group controlId="cedula_identidad">
              <Form.Label>Cédula de Identidad</Form.Label>
              <Form.Control
                type="text"
                name="cedula_identidad"
                value={formData.cedula_identidad ? `V-${formData.cedula_identidad}` : ''}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="V-123321123"
                maxLength={10}
                required
                className={
                  cedulaError || cedulaLengthError
                    ? 'is-invalid'
                    : isCedulaValid ? 'is-valid' : ''
                }
              />
              {cedulaError && <Alert variant="danger">{cedulaError}</Alert>}
              {!cedulaError && isCedulaValid && (
                <Form.Control.Feedback type="valid">
                  Cédula disponible.
                </Form.Control.Feedback>
              )}
            </Form.Group>
            <Row className="g-2"> 
            <Col md={6}>
            <Form.Group controlId="nombres">
              <Form.Label>Nombres</Form.Label>
              <Form.Control
                type="text"
                name="nombres"
                value={formData.nombres}
                onChange={handleChange}
                required
              />
            </Form.Group>
            </Col>
            <Col md={6}>
            <Form.Group controlId="apellidos">
              <Form.Label>Apellidos</Form.Label>
              <Form.Control
                type="text"
                name="apellidos"
                value={formData.apellidos}
                onChange={handleChange}
                required
              />
            </Form.Group>
            </Col>
            </Row>
            
            <Row className="g-2"> 
            <Col md={6}>
            <Form.Group controlId="fecha_nacimiento">
              <Form.Label>Fecha de Nacimiento</Form.Label>
              <Form.Control
                type="date"
                name="fecha_nacimiento"
                min={FECHA_NAC_MIN}
                max={FECHA_NAC_MAX}
                value={formData.fecha_nacimiento}
                onChange={handleChange}
                required
              />
            </Form.Group>
            </Col>
            <Col md={6}>

            <SelectComponent
              options={filterOptions.generoOptions} 
              nameField="descripcion"
              valueField="id"
              selectedValue={formData.genero_id}
              handleChange={handleChange}
              controlId="genero_id"
              label="Género"
              required
            />

            </Col>
            </Row>
            
            

            <Form.Group controlId="direccion">
              <Form.Label>Dirección</Form.Label>
              <Form.Control
                as="textarea"
                name="direccion"
                value={formData.direccion}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="email">
              <Form.Label>Dirección Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </Form.Group>
            <Row className="g-2"> 
            <Col md={6}>

            <Form.Group controlId="telefono_casa">
              <Form.Label>Teléfono de Casa (Opcional)</Form.Label>
              <Form.Control
                type="text"
                name="telefono_casa"
                value={formData.telefono_casa}
                onChange={handleChangeNumber}
              />
            </Form.Group>
            </Col>
            <Col md={6}>

            <Form.Group controlId="telefono_celular">
              <Form.Label>Teléfono Celular</Form.Label>
              <Form.Control
                type="text"
                name="telefono_celular"
                value={formData.telefono_celular}
                onChange={handleChangeNumber}
                required
              />
            </Form.Group>
            </Col>
            </Row>

            <Form.Group controlId="ocupacion">
              <Form.Label>Ocupación</Form.Label>
              <Form.Control
                type="text"
                name="ocupacion"
                value={formData.ocupacion}
                onChange={handleChange}
                required
              />
            </Form.Group>


            <Row className="g-2"> 
            <Col md={12}>
              
            <SelectComponent
              options={filterOptions.nivelOptions} 
              nameField="descripcion"
              valueField="id"
              selectedValue={formData.nivel_instruccion_id}
              handleChange={handleChange}
              controlId="nivel_instruccion_id"
              label="Nivel de Instrucción"
              required
            />

            </Col>
            {/* <Col md={6}>

            <SelectComponent
                  options={filterOptions.centroOptions} 
                  nameField="descripcion"
                  valueField="id"
                  selectedValue={formData.centro_id}
                  handleChange={handleChange}
                  controlId="centro_id"
                  label="Centro"
                />

            </Col> */}
            </Row>
            <Row className="g-2"> 
            <Col md={6}>

            <SelectComponent
              options={filterOptions.procedenciaOptions} 
              nameField="descripcion"
              valueField="id"
              selectedValue={formData.procedencia_id}
              handleChange={handleChange}
              controlId="procedencia_id"
              label="Procedencia"
              required
            />
            </Col>
            <Col md={6}>
            <SelectComponent
              options={filterOptions.superatecOptions} 
              nameField="descripcion"
              valueField="id"
              selectedValue={formData.como_entero_superatec_id}
              handleChange={handleChange}
              controlId="como_entero_superatec_id"
              label="¿Cómo se enteró de SUPERATEC? (Opcional)"
            />
            </Col>
            </Row>

            </div>
          </div>
          </div>
              </div>

          <div className="col-lg-5 "style={{ marginTop: '50px'}} >
          <div className="card-box" style={{ padding: '20px' }}>
            <h2>Información del Voluntariado</h2>
    
            <Row className="g-2"> 
            <Col md={6}>
            <SelectComponent
              options={filterOptions.tipoOptions} 
              nameField="descripcion"
              valueField="id"
              selectedValue={formData.tipo_voluntariado_id}
              handleChange={handleChange}
              controlId="tipo_voluntariado_id"
              label="Tipo de Voluntariado"
              required
            />

            </Col>
            <Col md={6}>

            <SelectComponent
              options={filterOptions.areaOptions} 
              nameField="descripcion"
              valueField="id"
              selectedValue={formData.area_voluntariado_id}
              handleChange={handleChange}
              controlId="area_voluntariado_id"
              label="Área de Voluntariado"
              required
            />

            </Col>
            </Row>
            <Row className="g-2"> 
            <Col md={6}>

            <SelectComponent
              options={filterOptions.centroOptions} 
              nameField="descripcion"
              valueField="id"
              selectedValue={formData.centro_id}
              handleChange={handleChange}
              controlId="centro_id"
              label="Centro"
              required
            />

            </Col>
            <Col md={6}>

            <Form.Group controlId="actividades_realizar">
              <Form.Label>Actividades a Realizar</Form.Label>
              <Form.Control
                as="textarea"
                name="actividades_realizar"
                value={formData.actividades_realizar}
                onChange={handleChange}
                required
              />
            </Form.Group>

            </Col>
            </Row>
            <Row className="g-2"> 
            <Col md={6}>

           <Form.Group controlId="horario">
              <Form.Label>Horario</Form.Label>
              <Form.Control
                as="textarea"
                name="horario"
                value={formData.horario}
                onChange={handleChange}
                required
              />
            </Form.Group>

            </Col>
            <Col md={6}>

            <Form.Group controlId="fecha_inicio">
              <Form.Label>Fecha de Inicio</Form.Label>
              <Form.Control
                type="date"
                name="fecha_inicio"
                value={formData.fecha_inicio}
                onChange={handleChange}
                required
              />
            </Form.Group>
            <Form.Group controlId="fecha_inicio">
              <Form.Label>Fecha de Fin</Form.Label>
              <Form.Control
                type="date"
                name="fecha_fin"
                value={formData.fecha_fin}
                onChange={handleChange}
                required
              />
            </Form.Group>

            </Col>
            </Row>

            <Form.Group controlId="horas_totales">
              <Form.Label>Horas Totales</Form.Label>
              <Form.Control
                type="number"
                name="horas_totales"
                value={formData.horas_totales}
                onChange={handleChange}
                required
              />
            </Form.Group>

             <SelectComponent
              options={filterOptions.EvalOptions} 
              nameField="descripcion"
              valueField="id"
              selectedValue={formData.eval_voluntariado_id}
              handleChange={handleChange}
              controlId="eval_voluntariado_id"
              label="Evaluaciòn opcional"
            />

            <Form.Group controlId="comentarios">
              <Form.Label>Comentarios (Opcional)</Form.Label>
              <Form.Control
                as="textarea"
                name="comentarios"
                value={formData.comentarios}
                onChange={handleChange}
              />
            </Form.Group>
          </div>
          <div className="button-container"  >
                <Button 
                    variant="info"
                    type="submit"
                    className="ms-2"
                >
                    Guardar
                </Button>

                <Button 
                    variant="secondary" 
                    onClick={() => navigate(-1)}
                    className="ms-2"
                >
                    Volver
                </Button>
            </div>
        </div>

    </div>
    </Form>
    
         {/* Modal para seleccionar usuario o rol */}
                    <Modal show={showConfirmModal && !selectedUserId && !selectedRoleId} onHide={() => setShowConfirmModal(false)}>
                 <Modal.Header closeButton>
                   <Modal.Title>Enviar Petición</Modal.Title>
                 </Modal.Header>
                 <Modal.Body>
                   Seleccione si desea enviar la petición de Confirmación a un Rol o Usuario en especifico
                 </Modal.Body>
                 <Modal.Footer>
                   <Button variant="secondary" onClick={() => setShowUserRoleModal(false)}>
                     Cancelar
                   </Button>
                   <Button variant="warning" onClick={() => {
                     setShowUserRoleModal(false);
                     setShowUserSearchModal(true);
                   }}>
                     Buscar Usuario
                   </Button>
                   <Button variant="info" onClick={() => {
                     setShowUserRoleModal(false);
                     setShowRoleSearchModal(true);
                   }}>
                     Buscar Rol
                   </Button>
                 </Modal.Footer>
               </Modal>
         
               {/* Modal de búsqueda de usuarios */}
               <Modal show={showUserSearchModal} onHide={() => setShowUserSearchModal(false)}>
                 <Modal.Header closeButton>
                   <Modal.Title>Buscar Usuario</Modal.Title>
                 </Modal.Header>
                 <Modal.Body>
                 <div className="d-flex align-items-center">
                   <Form.Control
                     name="username"
                     type="text"
                     placeholder="Buscar por nombre"
                     value={filters.username}
                     onChange={handleFilterChange}
                     className="me-2"
                   />
                   <Button 
                       variant="info me-2" 
                       onClick={getAllUsers}
                       style={{ padding: '5px 10px', width: '120px' }} // Ajusta padding y ancho
                   >
                       <FaSearch className="me-1" /> {/* Ícono de lupa */}
                   </Button>
                   </div>
                   <Table striped bordered hover>
                     <thead>
                       <tr>
                         <th>ID</th>
                         <th>Nombre</th>
                         <th>Acciones</th>
                       </tr>
                     </thead>
                     <tbody>
                       {paginatedUsers.length > 0 ? (
                           paginatedUsers.map(user => (
                               <tr key={user.id}>
                                   <td>{user.id}</td>
                                   <td>{user.username}</td>
                                   <td>
                                   <div className="d-flex justify-content-center align-items-center">
         
                                         <Button variant="info" onClick={() => handleSelectUser(user)} className="me-2">
                                             <i className="bi bi-check2-square"></i>
                                         </Button>
                                     </div>
                                   </td>
                               </tr>
                           ))
                       ) : (
                           <tr>
                               <td colSpan="3">No se encontraron usuarios.</td>
                           </tr>
                       )}
                   </tbody>
         
                   </Table>
                   <div className="d-flex justify-content-between mt-3">
                   <Button
                     variant="secondary"
                       onClick={() => handleUserPageChange(currentPageUsers - 1)}
                       disabled={currentPageUsers === 1}
                   >
                       Anterior
                   </Button>
                   <Button
                       variant="secondary"
                       onClick={() => handleUserPageChange(currentPageUsers + 1)}
                       disabled={currentPageUsers === totalPages}
                   >
                       Siguiente
                   </Button>
         
                   </div>
                 </Modal.Body>
                 <Modal.Footer>
                   <Button variant="secondary" onClick={() => setShowUserSearchModal(false)}>
                     Cerrar
                   </Button>
                   <Button variant="light" onClick={() => {
                     setShowUserSearchModal(false);
                     setShowUserRoleModal(true);
                   }}>
                     Volver
                   </Button>
                 </Modal.Footer>
               </Modal>
         
               {/* Modal de búsqueda de roles */}
               <Modal show={showRoleSearchModal} onHide={() => setShowRoleSearchModal(false)}>
                 <Modal.Header closeButton>
                   <Modal.Title>Buscar Rol</Modal.Title>
                 </Modal.Header>
                 <Modal.Body>
                 <div className="d-flex align-items-center">
                   <Form.Control
                     name="name"
                     type="text"
                     placeholder="Buscar por nombre"
                     value={filters.name}
                     onChange={handleFilterChange}
                     className="me-2" // Margen derecho para separar del botón
                     style={{ flex: 1 }} // Ajusta el ancho para que ocupe el espacio disponible
                   />
                   <Button
                     variant="info"
                     onClick={getAllRoles}
                     style={{ whiteSpace: 'nowrap' }} // Evita que el texto del botón se rompa en varias líneas
                   >
                     <FaSearch className="me-1" /> Buscar {/* Ícono de lupa */}
                   </Button>
                 </div>
         
                   <Table striped bordered hover>
                     <thead>
                       <tr>
                         <th>ID</th>
                         <th>Nombre</th>
                         <th>Acciones</th>
                       </tr>
                     </thead>
                     <tbody>
                     {paginatedRoles.length > 0 ? (
                         paginatedRoles.map(role => (
                             <tr key={role.id}>
                                 <td>{role.id}</td>
                                 <td>{role.name}</td>
                                 <td>
         
                                     <div className="d-flex justify-content-center align-items-center">
         
                                       <Button variant="info" onClick={() => handleSelectRole(role)} className="me-2">
                                           <i className="bi bi-check2-square"></i>
                                       </Button>
                                     </div>
                                 </td>
                             </tr>
                         ))
                     ) : (
                         <tr>
                             <td colSpan="3">No se encontraron roles.</td>
                         </tr>
                     )}
                 </tbody>
         
                   </Table>
                   <div className="d-flex justify-content-between mt-3">
                   <Button
                     variant="secondary"
                     onClick={() => handleRolePageChange(currentPageRoles - 1)}
                     disabled={currentPageRoles === 1}
                 >
                     Anterior
                 </Button>
                 <Button
                     variant="secondary"
                     onClick={() => handleRolePageChange(currentPageRoles + 1)}
                     disabled={currentPageRoles === totalPages}
                 >
                     Siguiente
                 </Button>
         
                   </div>
                 </Modal.Body>
                 <Modal.Footer>
                   <Button variant="secondary" onClick={() => setShowRoleSearchModal(false)}>
                     Cerrar
                   </Button>
                   <Button variant="light" onClick={() => {
                     setShowRoleSearchModal(false);
                     setShowUserRoleModal(true);
                   }}>
                     Volver
                   </Button>
                 </Modal.Footer>
               </Modal>
         
         
               {/* Modal de confirmación para enviar la solicitud al usuario */}
               <Modal show={selectedUserId !== null && showConfirmModal} onHide={() => setShowConfirmModal(false)}>
                 <Modal.Header closeButton>
                   <Modal.Title>Confirmar Envío de Solicitud</Modal.Title>
                 </Modal.Header>
                 <Modal.Body>
                   {selectedUserId
                     ? `¿Seguro que deseas enviar la solicitud al usuario ${selectedUserName}?`
                     : 'No se ha seleccionado ningún usuario.'}
                 </Modal.Body>
                 <Form.Group controlId="comentario" style={{ margin: '10px 20px' }}>
                   <Form.Label>Comentario (opcional)</Form.Label>
                   <Form.Control
                     as="textarea"
                     rows={3}
                     placeholder="Agrega un comentario sobre lo que hiciste o lo que falta."
                     value={comentario}
                     onChange={(e) => setComentario(e.target.value)}
                     style={{ padding: '5px', resize: 'none' }}
                   />
                 </Form.Group>
                 <Modal.Footer>
                   <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>Cancelar</Button>
                   <Button variant="success" onClick={handleConfirmSendRequest} disabled={!selectedUserId}>Confirmar</Button>
                   <Button variant="light" onClick={() => {
                     setShowConfirmModal(false);
                     setShowUserSearchModal(true);
                   }}>
                     Volver
                   </Button>
                 </Modal.Footer>
               </Modal>
         
               {/* Modal de confirmación para enviar la solicitud al rol */}
               <Modal show={selectedRoleId !== null && showConfirmModal} onHide={() => setShowConfirmModal(false)}>
                 <Modal.Header closeButton>
                   <Modal.Title>Confirmar Envío de Solicitud</Modal.Title>
                 </Modal.Header>
                 <Modal.Body>
                   {selectedRoleId
                     ? <p>¿Seguro que deseas enviar la solicitud al rol {selectedRoleName}?</p>
                     : <p>No se ha seleccionado ningún rol.</p>}
                   <Form.Group controlId="comentario" style={{ margin: '10px 0' }}>
                     <Form.Label>Comentario (opcional)</Form.Label>
                     <Form.Control
                       as="textarea"
                       rows={3}
                       placeholder="Agrega un comentario sobre lo que hiciste o lo que falta."
                       value={comentario}
                       onChange={(e) => setComentario(e.target.value)}
                       style={{ padding: '5px', resize: 'none' }}
                     />
                   </Form.Group>
                 </Modal.Body>
                 <Modal.Footer>
                   <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>Cancelar</Button>
                   <Button variant="success" onClick={handleConfirmSendRequest} disabled={!selectedRoleId}>Confirmar</Button>
                   <Button variant="light" onClick={() => {
                     setShowConfirmModal(false);
                     setShowRoleSearchModal(true);
                   }}>Volver</Button>
                 </Modal.Footer>
               </Modal>
   

    </div>
    

    
    
  );
};

export default CreateVoluntariados;
